import { render, staticRenderFns } from "./FundingPane.vue?vue&type=template&id=6675f23c&scoped=true"
import script from "./FundingPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./FundingPane.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675f23c",
  null
  
)

export default component.exports